import { useState } from 'react';
import PricingCard from './PricingCard';

export default function PricingPlans({ title, plans }) {
	const [isMonthly, setIsMonthly] = useState(true);

	return (
		<div className="pb-12 pt-20 mt-3 bg-[#1a1a1a]" id="pricing-section-marketing">
			<div className='container'>
				{/* Header */}
				<h3 className="text-3xl md:text-4xl text-center font-bold text-white md:leading-tight mb-16">
					{title}
				</h3>

				{/* Pricing Cards */}
				<div className="grid grid-cols-1 lg:grid-cols-3 gap-6 max-w-7xl mx-auto">
					{plans.map((plan, index) => (
						<PricingCard key={index} plan={plan} isMonthly={isMonthly} />
					))}
				</div>
			</div>
		</div>
	);
}
